import { SET_APP_STATE } from './actions'

export const FIRST_TOPICS_FETCH = 'firstTopicsFetch'
export const FIRST_DIRECT_CHATS_FETCH = 'firstDirectChatsFetch'
export const FIRST_LIVE_CHATS_FETCH = 'firstLiveChatsFetch'

const initialAppState = {
  [FIRST_TOPICS_FETCH]: true,
  [FIRST_DIRECT_CHATS_FETCH]: true,
  [FIRST_LIVE_CHATS_FETCH]: true,
}

export const appState = (state = initialAppState, action) => {
  switch (action.type) {
    case SET_APP_STATE:
      return {
        ...state,
        [action.key]: action.value,
      }
    default:
      return state
  }
}
